import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue } from "react";
import isNumber from "lodash/isNumber";
import isObject from "lodash/isObject";
import { warning } from "@lilib/utils";
import useUpdate from "./useUpdate";
import useTimeout from "./useTimeout";
import useSafeState from "./useSafeState";
function useDelayedValue(value, options) {
  var delay = 0;
  var include = function include(value) {
    return true;
  };
  var compare = Object.is;
  if (isNumber(options)) {
    delay = options;
  } else if (isObject(options)) {
    delay = +options.delay;
    if (options.include) {
      include = options.include;
    }
    if (options.compare) {
      compare = options.compare;
    }
  }
  if (process.env.NODE_ENV !== "production") {
    warning(!isNumber(delay) || !(delay > 0), "You should provide a positive number as the delay time.", {
      scope: "useDelayedValue"
    });
  }
  var _useSafeState = useSafeState(value),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    state = _useSafeState2[0],
    setState = _useSafeState2[1];
  var _useTimeout = useTimeout(function () {
      return setState(value);
    }, delay),
    _useTimeout2 = _slicedToArray(_useTimeout, 2),
    update = _useTimeout2[0],
    cancelUpdate = _useTimeout2[1];
  useUpdate(function () {
    if (!compare(value, state)) {
      if (include(value)) {
        update();
      } else {
        setState(value);
      }
    } else {
      cancelUpdate();
    }
  }, [value]);
  useDebugValue(state);
  return state;
}
export default useDelayedValue;